import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Settings|Roles|Copy Confirmation|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSettingsRolesCopyConfirmation';
export type SPSettingsRolesCopyConfirmationLocNames =
	| `${LocNameStart}Title`
	| `${LocNameStart}ContentConfirmCopy`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonSave`;

export const spSettingsRolesCopyConfirmationLocs: LocDefs<SPSettingsRolesCopyConfirmationLocNames> =
	{
		SPSettingsRolesCopyConfirmationTitle: {
			defaultValue: 'Please Confirm',
			description: 'Modal Title',
			displayPath: `${pathStart}Modal Title`,
			displayType: 'Title',
			legacyName: 'Core/Settings.Roles.Title.ConfirmCopy',
			...sharedProperties,
		},
		SPSettingsRolesCopyConfirmationContentConfirmCopy: {
			defaultValue:
				'Any currently assigned permissions will be overwritten with the permission from the selected role',
			description: 'Text to confirm copying of a role',
			displayPath: `${pathStart}Confirm Copy text`,
			displayType: 'Title',
			legacyName: 'Core/Settings.Roles.Content.ConfirmCopy',
			...sharedProperties,
		},
		SPSettingsRolesCopyConfirmationButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			legacyName: 'Core/Settings.Roles.Button.ConfirmCopyCancel',
			...sharedProperties,
		},
		SPSettingsRolesCopyConfirmationButtonSave: {
			defaultValue: 'Copy Permissions',
			description: 'Save button',
			displayPath: `${pathStart}Save`,
			displayType: 'Button',
			legacyName: 'Core/Settings.Roles.Button.ConfirmCopySave',
			...sharedProperties,
		},
	};

export type SPSettingsRolesCopyConfirmationLocType =
	LocMap<SPSettingsRolesCopyConfirmationLocNames>;
